/**
 * Capacitor plugin for printing documents, HTML, PDFs, images and web views on iOS and Android.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/@capgo/capacitor-printer
 */

import { mobilePlugins } from "@/shared/mobileHelper";
import { Directory, downloadFile } from "@/shared/nativePlugins/fileHelper";
import * as datadog from "@/shared/datadog";

/**
 * Presents the printing UI to print PDF documents.
 * @param args - url:string - full url of a pdf file.
 * @param args - name:string - name of the print job. Usage: - Displayed in the system print queue
 * - Shown in print history/logs
 * - May appear in printer status displays
 * - Used as default filename for "Save as PDF" option Platform Behavior:
 * - iOS: Shown in print preview header and activity view
 * - Android: Displayed in print job notification and print queue
 */
export async function printPdf (args: {url: string, name: string}) {
  try {
    const downloadFileResult = await downloadFile({ url: args.url, directory: Directory.Data, trackProgress: false });
    return await mobilePlugins.Printer.printPdf({
      name: args.name,
      path: `${String(downloadFileResult.path)}`
    });
  } catch (err) {
    datadog.log("Mobile print error.", err, "error");
    throw err;
  }
}